define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PermitLandtype = void 0;
    class PermitLandtype extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "PermitId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LandtypeCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LandtypeCodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LandtypeName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LandtypeNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Amount", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AmountError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Units", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UnitsError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Permit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, PermitLandtype.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Permit = parent;
            this.PermitId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Permit = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.PermitId = (0, EntityUtil_1.toInt)(entity.PermitId);
            a.LandtypeCode = b.LandtypeCode;
            a.LandtypeName = b.LandtypeName;
            a.Amount = (0, EntityUtil_1.toFloat)(entity.Amount);
            a.Units = b.Units;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, PermitLandtype.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                PermitId: this.PermitId,
                LandtypeCode: this.LandtypeCode,
                LandtypeName: this.LandtypeName,
                Amount: this.Amount,
                Units: this.Units,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.PermitLandtype = PermitLandtype;
    Object.defineProperty(PermitLandtype, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "PermitLandtype"
    });
    Object.defineProperty(PermitLandtype, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Land Type Residuals to be Retained"
    });
    Object.defineProperty(PermitLandtype, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "PermitId", "LandtypeCode", "LandtypeName", "Amount", "Units"]
    });
    Object.defineProperty(PermitLandtype, "PermitIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitLandtype, "LandtypeCodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(PermitLandtype, "LandtypeCodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitLandtype, "LandtypeNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 70
    });
    Object.defineProperty(PermitLandtype, "LandtypeNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitLandtype, "AmountReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitLandtype, "UnitsLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(PermitLandtype, "UnitsDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PermitLandtype, "UnitsReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLandtype.prototype, "PermitId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLandtype.prototype, "PermitIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLandtype.prototype, "LandtypeCode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLandtype.prototype, "LandtypeCodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLandtype.prototype, "LandtypeName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLandtype.prototype, "LandtypeNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLandtype.prototype, "Amount", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLandtype.prototype, "AmountError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLandtype.prototype, "Units", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLandtype.prototype, "UnitsError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLandtype.prototype, "Permit", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLandtype.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLandtype.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLandtype.prototype, "merge", null);
});
